import { useMemo } from "react";
import dynamic from "next/dynamic";

import { useAppSelector } from "@chef/state-management/hooks";

const StandaloneProductModal = dynamic(
  () =>
    import("./StandaloneProductModal").then(
      (mod) => mod.StandaloneProductModal,
    ),
  {
    ssr: false,
  },
);

const MyMenuSelectWeekModal = dynamic(
  () =>
    import("./MyMenuSelectWeekModal").then((mod) => mod.MyMenuSelectWeekModal),
  {
    ssr: false,
  },
);

const RecipeModal = dynamic(
  () => import("./RecipeModal").then((mod) => mod.RecipeModal),
  {
    ssr: false,
  },
);

const WeekPortionsModal = dynamic(
  () => import("./WeekPortionsModal").then((mod) => mod.WeekPortionsModal),
  {
    ssr: false,
  },
);

const ConfirmRevertModal = dynamic(
  () => import("./ConfirmRevertModal").then((mod) => mod.ConfirmRevertModal),
  {
    ssr: false,
  },
);
const SubscribedStandaloneModal = dynamic(
  () =>
    import("./SubscribedStandaloneModal").then(
      (mod) => mod.SubscribedStandaloneModal,
    ),
  {
    ssr: false,
  },
);

const WeekSchedulerEditorModal = dynamic(
  () =>
    import("./WeekSchedulerEditor").then((mod) => mod.WeekSchedulerEditorModal),
  {
    ssr: false,
  },
);

const OverrideFeatureFlagsModal = dynamic(
  () =>
    import("./OverrideFeatureFlagsModal").then(
      (mod) => mod.OverrideFeatureFlagsModal,
    ),
  {
    ssr: false,
  },
);

const ResumeOngoingDeviationModal = dynamic(
  () =>
    import("./ResumeOngoingDeviationModal").then(
      (mod) => mod.ResumeOngoingDeviationModal,
    ),
  {
    ssr: false,
  },
);

const PersonalisedRecipesModal = dynamic(
  () =>
    import("./PersonalisedRecipes").then((mod) => mod.PersonalisedRecipesModal),
  {
    ssr: false,
  },
);

export const ModalProvider = () => {
  const { open, data } = useAppSelector((state) => state.modal.modal);

  const Modal = useMemo(() => {
    if (!open) {
      return null;
    }

    switch (data.id) {
      case "STANDALONE_PRODUCT":
        return <StandaloneProductModal {...data} />;

      case "MY_MENU_SELECT_WEEK":
        return <MyMenuSelectWeekModal />;

      case "RECIPE":
        return <RecipeModal {...data} />;

      case "SUBSCRIBED_STANDALONE":
        return <SubscribedStandaloneModal {...data} />;

      case "WEEK_SCHEDULER_EDITOR":
        return <WeekSchedulerEditorModal {...data} />;

      case "OVERRIDE_FEATURE_FLAGS":
        return <OverrideFeatureFlagsModal />;

      case "RESUME_ONGOING_DEVIATION":
        return <ResumeOngoingDeviationModal {...data} />;

      case "PERSONALISED_RECIPES":
        return <PersonalisedRecipesModal {...data} />;

      case "WEEK_PORTION":
        return <WeekPortionsModal {...data} />;

      case "CONFIRM_REVERT":
        return <ConfirmRevertModal {...data} />;

      default:
        return null;
    }
  }, [open, data]);

  return Modal;
};
